var STICKY_BEHAVIOR;
(function (STICKY_BEHAVIOR) {
    STICKY_BEHAVIOR["ON_SCROLL"] = "on scroll";
    STICKY_BEHAVIOR["PERSISTENT"] = "persistent";
})(STICKY_BEHAVIOR || (STICKY_BEHAVIOR = {}));
var STICKY_POSITION;
(function (STICKY_POSITION) {
    STICKY_POSITION["TOP"] = "top";
    STICKY_POSITION["BOTTOM"] = "bottom";
})(STICKY_POSITION || (STICKY_POSITION = {}));
var TRIGGER_POSITION;
(function (TRIGGER_POSITION) {
    TRIGGER_POSITION["ABOVE"] = "above";
    TRIGGER_POSITION["INSIDE"] = "inside";
    TRIGGER_POSITION["BELOW"] = "below";
})(TRIGGER_POSITION || (TRIGGER_POSITION = {}));
const THROTTLE_SCROLL_DELAY = 350; // 350 milliseconds because it is a good balance between performance and responsiveness

export { STICKY_BEHAVIOR, STICKY_POSITION, THROTTLE_SCROLL_DELAY, TRIGGER_POSITION };
